<template>
  <el-carousel
    :interval="interval"
    :height="height"
    arrow="always"
    indicator-position="outside"
    @change="handleChange"
  >
    <el-carousel-item v-for="item in items" :key="item.ArticleId">
      <router-link
        target="_blank"
        :to="{
          path: '/text',
          query: { articleId: item.ArticleId, index: 1, secondindex: 1 },
        }"
      >
        <img
          v-if="item.ScrollImgList[0].ImgUrl"
          :src="item.ScrollImgList[0].ImgUrl"
          alt=""
        />
        <img v-else src="../assets/img/tjszgyy01.jpg" alt="" />

        <div class="carousel-item-text">
          <h3>{{ item.Title }}</h3>
          <p>{{ item.Time }}</p>
        </div>
      </router-link>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "Carousel",
  props: {
    items: {
      type: Array,
      required: true,
    },
    interval: {
      type: Number,
      default: 5000,
    },
    height: {
      type: String,
      default: "300px",
    },
  },
  methods: {
    handleChange(index) {
      // console.log(`轮播图切换到第 ${index + 1} 张`);
    },
  },
};
</script>
<style>
.carousel-item-text {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 1.2rem;
  box-sizing: border-box;
  font-size: 1rem;
  font-weight: 300;
}

.carousel-item-text h3 {
  width: 75%;
  margin-top: 0;
  margin-bottom: 0.6rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  cursor: pointer;
}

.carousel-item-text p {
  margin-top: 0;
  margin-bottom: 0;
  color: #c4c4c4;
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-item-enter-active,
.carousel-item-leave-active {
  transition: all 0.5s;
}

.carousel-item-enter,
.carousel-item-leave-to {
  opacity: 0;
}
/* 隐藏左右箭头 */
.el-carousel__arrow {
  display: none !important;
}
/* 修改指示器样式 */
.el-carousel__indicators--outside {
  position: absolute !important;
  right: -11.4rem;
}
.el-carousel__button {
  width: 0.9rem !important;
  height: 0.9rem !important;
  border-radius: 50%;
}
.el-carousel__indicators--outside button {
  background-color: #fff !important;
  opacity: 1 !important;
}
.el-carousel__indicator.is-active button {
  background-color: #087ca3 !important;
}
</style>
